import type { UserResponse } from "@/app/types";
import type { TrackingContext } from "./types";

/**
 * Build a TrackingContext from employer (UserResponse) data.
 *
 * Returns undefined when no user or no email is available,
 * so callers can pass the result directly as `context?`.
 */
export function buildEmployerContext(
  user: UserResponse | null | undefined
): TrackingContext | undefined {
  if (!user?.email) return undefined;

  return {
    userEmail: user.email,
    userId: user.id,
    userName: user.name ?? undefined,
    userPhone: user.companyPhoneNumber ?? undefined,
    userZip: user.postCode ?? undefined,
  };
}
